module.exports = __webpack_public_path__ + "img/fondo-becas_03.22f3dab6.jpg";